/**
 * Purchases section filter field definitions.
 * Used by FilterBuilder to render the correct input for each field.
 */
import {
  COMMON_FILTER_OPERATORS,
  BOOLEAN_OPTIONS,
  PLATFORM_OPTIONS_IOS_ANDROID,
  type FilterFieldMeta,
} from '@/lib/filters';

export const PURCHASES_FILTER_FIELDS = [
  { value: 'status', label: 'status' },
  { value: 'platform', label: 'platform' },
  { value: 'country', label: 'country' },
  { value: 'offering_id', label: 'offering_id' },
  { value: 'subscription_period', label: 'subscription_period' },
  { value: 'purchase_structure', label: 'purchase_structure' },
  { value: 'campaign_name', label: 'campaign_name' },
  { value: 'traffic_source_name', label: 'traffic_source_name' },
  { value: 'ad_group_name', label: 'ad_group_name' },
  { value: 'traffic_source', label: 'traffic_source' },
  { value: 'total_revenue_try', label: 'total_revenue_try' },
  { value: 'renewal_count', label: 'renewal_count' },
  { value: 'retention_days', label: 'retention_days' },
  { value: 'is_web_to_app_user', label: 'is_web_to_app_user' },
  { value: 'app_version', label: 'app_version' },
  { value: 'city', label: 'city' },
] as const;

export const PURCHASES_FILTER_OPERATORS = COMMON_FILTER_OPERATORS;

export const PURCHASES_FILTER_FIELD_META: FilterFieldMeta = {
  status: {
    type: 'dropdown',
    options: [
      { value: 'active', label: 'Active' },
      { value: 'cancelled', label: 'Cancelled' },
      { value: 'expired', label: 'Expired' },
      { value: 'billing_issue', label: 'Billing Issue' },
    ],
  },
  platform: { type: 'dropdown', options: [...PLATFORM_OPTIONS_IOS_ANDROID] },
  is_web_to_app_user: { type: 'dropdown', options: [...BOOLEAN_OPTIONS] },
  country: { type: 'text', placeholder: 'e.g., Turkey' },
  city: { type: 'text', placeholder: 'e.g., Istanbul' },
  offering_id: { type: 'text', placeholder: 'e.g., W_Y' },
  subscription_period: { type: 'text', placeholder: 'e.g., weekly, yearly' },
  purchase_structure: { type: 'text', placeholder: 'e.g., onboarding' },
  campaign_name: { type: 'text', placeholder: 'e.g., PL Tier 1' },
  traffic_source_name: { type: 'text', placeholder: 'e.g., PL Tier 2' },
  ad_group_name: { type: 'text', placeholder: 'e.g., Text Only Group' },
  traffic_source: { type: 'text', placeholder: 'e.g., google_ads, organic' },
  total_revenue_try: { type: 'text', placeholder: 'e.g., 100' },
  renewal_count: { type: 'text', placeholder: 'e.g., 3' },
  retention_days: { type: 'text', placeholder: 'e.g., 7' },
  app_version: { type: 'text', placeholder: 'e.g., 2.9.3' },
};
